/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import { useMaterialUIController } from "context";
import colors from "assets/theme/base/colors";

function CustomerCell({ image = "", name, color = "transparent" }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <MDBox display="flex" alignItems="center">
      <MDBox mr={1}>
        <MDAvatar bgColor={color} src={image} alt={name} size="xs" />
      </MDBox>
      <MDTypography
        // variant="caption"
        // fontWeight="medium"
        // color="secondary"
        // // "text-stone-600"
        // sx={{ lineHeight: 0 }}
        sx={({ typography: { size, fontWeightBold } }) => ({
          lineHeight: 0,
          fontSize: size.xs,
          fontWeight: fontWeightBold,
          color: darkMode ? "white" : colors.secondary.main,
        })}
      >
        {name}
      </MDTypography>
    </MDBox>
  );
}

// Typechecking props for the CustomerCell
CustomerCell.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  color: PropTypes.oneOf([
    "transparent",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
};

export default CustomerCell;
